<template>
  <CCol sm="6" md="4">
    <CCard>
      <CCardHeader>
        <b>{{ group_name }}</b>:
        {{ release_date_hms }}
        <div class="card-header-actions">
          <CIcon name="cil-history" v-if="reviewed"/>
          <CLink :href="youtube_link" class="card-header-action">
            <CIcon name="cib-youtube"/>
          </CLink>
          <small class="text-muted">{{ duration_hms }}</small>
        </div>
      </CCardHeader>
      <CCardBody>
        <CCardTitle>
          <h3 v-html="title"></h3>
        </CCardTitle>
        <youtube :video-id="youtube_id" player-width="480" player-height="270"></youtube>
        <CCardFooter v-if="description">
          {{ description }}
        </CCardFooter>
      </CCardBody>
      <CCardFooter>
        <CButton block variant="outline" color="success" :disabled="inProgress" size="lg" :pressed="isActive"
                 @click="inRatingUpdate">
          {{ isActive ? 'В лучшем' : 'В лучшее' }}
        </CButton>
      </CCardFooter>
    </CCard>
  </CCol>
</template>

<script>
export default {
  name: 'YoutubeVideoCard',
  props: [
    'id',
    'title',
    'description',
    'youtube_id',
    'in_rating',
    'reviewed',
    'group_name',
    'duration',
    'release_date',
  ],
  mounted () {

  },
  data () {
    return {
      isActive: (this.in_rating == true),
      inProgress: false,
      isCollapsed: true,
    };
  },
  computed: {
    duration_hms: function () {
      if (this.duration == null) {
        return '-';
      }
      var date = new Date(2020, 1, 1, 0, 0, 0);
      date.setSeconds(this.duration);
      var hasHours = (date.getHours() > 0);
      return hasHours ? this.$moment(date).format('HH:mm:ss') : this.$moment(date).format('mm:ss');
    },
    release_date_hms: function () {
      var date = new Date(this.release_date);
      return this.$moment(date).format('DD.MM.YYYY');
    },
    youtube_link: function () {
      return 'https://www.youtube.com/watch?v=' + this.youtube_id;
    },
  },
  methods: {
    inRatingUpdate () {
      this.inProgress = true;
      this.$http.post('/api/video/' + this.id,
          {
            in_rating: !this.isActive,
          },
      ).then(response => {
        this.inProgress = false;
        this.isActive = response.data.data.in_rating;
      });
    },
  },
  watch: {
    /*isActive: function (val) {

    },*/
  },
};
</script>

<style scoped>

</style>